import { Euler, Vector3 } from "three";
import { navMeshService } from "../navMesh";
import { renderManager } from "./RenderManager";
import { localPlayerContainer } from "../localplayer/LocalPlayerContainer";
const _PI_2 = Math.PI / 2;
export class FirstPersonControls {
    constructor(object) {
        this.object = object;
        this.enabled = true;
        this.movementSpeed = 2;
        this.lookSpeed = 1;
        this.activeLook = true;
        // Set to constrain the pitch of the camera
        // Range is 0 to Math.PI radians
        this.minPolarAngle = 0; // radians
        this.maxPolarAngle = Math.PI; // radians
        this.moveDelta = new Vector3();
        this.rotateDelta = new Vector3();
        this.euler = new Euler(0, 0, 0, "YXZ");
        this.moved = new Vector3();
        this.forwardVector = new Vector3();
        this.rightVector = new Vector3();
        this.newPosition = new Vector3();
        this.shouldRecomputeNavGroupAndNavNode = true;
        this.headHeight = 1.7;
        this.startFeetPosition = new Vector3();
        this.desiredFeetPosition = new Vector3();
        this.navMeshPosition = new Vector3();
        this.canFly = false;
    }
    changeNavMeshLayerId() {
        this.shouldRecomputeNavGroupAndNavNode = true;
    }
    update(delta) {
        if (!this.enabled)
            return;
        if (renderManager.isXRPresenting())
            return;
        const actualMoveSpeed = delta * this.movementSpeed;
        this.moved.setScalar(0);
        this.moveDelta.normalize();
        this.moved.x += this.moveDelta.x;
        this.moved.z += this.moveDelta.z;
        if (this.moveDelta.y > 0)
            this.object.translateY(this.moveDelta.y * actualMoveSpeed);
        if (this.moveDelta.y < 0)
            this.object.translateY(this.moveDelta.y * actualMoveSpeed);
        this.moveDelta.setScalar(0);
        this.newPosition.copy(this.object.position);
        // moveForward
        this.forwardVector.setFromMatrixColumn(this.object.matrix, 0);
        this.forwardVector.crossVectors(this.object.up, this.forwardVector);
        this.rightVector.setFromMatrixColumn(this.object.matrix, 0);
        let headHeight = this.headHeight;
        if (this.canFly && this.navNodeGroup && !this.shouldRecomputeNavGroupAndNavNode) {
            headHeight = this.object.position.y - this.navMeshPosition.y;
        }
        this.newPosition.addScaledVector(this.forwardVector, this.moved.z * actualMoveSpeed);
        this.newPosition.addScaledVector(this.rightVector, this.moved.x * actualMoveSpeed);
        this.startFeetPosition.copy(this.object.position);
        this.desiredFeetPosition.copy(this.newPosition);
        const isMoving = this.startFeetPosition.distanceToSquared(this.desiredFeetPosition) > 0.0000001 * 0.0000001;
        if (isMoving || this.shouldRecomputeNavGroupAndNavNode) {
            localPlayerContainer.transformPointFromPlatformToWorldCoordinates(this.startFeetPosition);
            this.startFeetPosition.y -= headHeight;
            localPlayerContainer.transformPointFromPlatformToWorldCoordinates(this.desiredFeetPosition);
            this.desiredFeetPosition.y -= headHeight;
            if (!this.navNodeGroup || this.shouldRecomputeNavGroupAndNavNode) {
                this.shouldRecomputeNavGroupAndNavNode = false;
                this.navNodeGroup = navMeshService.createNodeGroup(navMeshService.currentLayerId, this.desiredFeetPosition);
                if (!this.navNodeGroup.navNode && navMeshService.hasLayer(navMeshService.currentLayerId)) {
                    this.shouldRecomputeNavGroupAndNavNode = true;
                }
            }
            const savedY = this.object.position.y;
            if (navMeshService.findPositionOnNavMesh(this.navNodeGroup, this.startFeetPosition, this.desiredFeetPosition, this.navMeshPosition)) {
                localPlayerContainer.transformPointFromWorldToPlatformCoordinates(this.navMeshPosition);
                this.object.position.copy(this.navMeshPosition);
                if (this.canFly) {
                    if (savedY - this.headHeight < this.object.position.y) {
                        this.object.position.y = this.object.position.y + this.headHeight;
                    }
                    else {
                        this.object.position.y = savedY;
                    }
                }
                else {
                    this.object.position.y += headHeight;
                }
            }
            else {
                this.object.position.copy(this.newPosition);
            }
        }
        let actualLookSpeed = delta * this.lookSpeed;
        if (!this.activeLook) {
            actualLookSpeed = 0;
        }
        this.euler.setFromQuaternion(this.object.quaternion);
        if (this.rotateDelta.y !== 0) {
            this.euler.y += this.rotateDelta.y * actualLookSpeed;
            this.object.quaternion.setFromEuler(this.euler);
        }
        if (this.rotateDelta.x !== 0) {
            this.euler.x += this.rotateDelta.x * actualLookSpeed;
            this.euler.x = Math.max(_PI_2 - this.maxPolarAngle, Math.min(_PI_2 - this.minPolarAngle, this.euler.x));
            this.object.quaternion.setFromEuler(this.euler);
        }
        this.rotateDelta.setScalar(0);
    }
}
